import React, { useState } from "react";
import "../../styles/components/food-menu-accordion.css";

export default function EditableFoodMenuAccordion({ value = [], onChange }) {
  const [expanded, setExpanded] = useState(null);
  const menu = value && Array.isArray(value) ? value : [];

  const handleChange = (weekIdx, dayIdx, field, val) => {
    const updated = menu.map((week, wIdx) =>
      wIdx === weekIdx
        ? {
            ...week,
            days: week.days.map((day, dIdx) =>
              dIdx === dayIdx ? { ...day, [field]: val } : day
            )
          }
        : week
    );
    onChange && onChange(updated);
  };

  return (
    <div className="food-menu-accordion">
      {menu.map((week, weekIdx) => (
        <div key={week.week} className="food-menu-accordion-item">
          <button
            className="food-menu-accordion-header"
            onClick={() => setExpanded(expanded === weekIdx ? null : weekIdx)}
            type="button"
          >
            <span>Week {week.week}</span>
            <span className="accordion-symbol">{expanded === weekIdx ? "–" : "+"}</span>
          </button>
          {expanded === weekIdx && (
            <div className="food-menu-accordion-panel">
              <table className="food-menu-table">
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>Morning Snack</th>
                    <th>Lunch</th>
                    <th>Afternoon Snack</th>
                  </tr>
                </thead>
                <tbody>
                  {week.days.map((d, dayIdx) => (
                    <tr key={d.day}>
                      <td>{d.day}</td>
                      <td>
                        <textarea
                          value={d.morning}
                          onChange={e => handleChange(weekIdx, dayIdx, "morning", e.target.value)}
                        />
                      </td>
                      <td>
                        <textarea
                          value={d.lunch}
                          onChange={e => handleChange(weekIdx, dayIdx, "lunch", e.target.value)}
                        />
                      </td>
                      <td>
                        <textarea
                          value={d.afternoon}
                          onChange={e => handleChange(weekIdx, dayIdx, "afternoon", e.target.value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
} 